import gql from 'graphql-tag';

export const UPDATE_CALENDAR_VIEW = gql`
  mutation SaveCalendarViewConfiguration($input: UpdateCalendarViewInput!) {
    dealActivity {
      result: updateCalendarView(input: $input) {
        error
        success
        entity {
          id
          name
          color
          owner {
            id
            fullName
          }
        }
      }
    }
  }
`;
